import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { Icon } from '@homeexchange/design';

import i18n from '../../i18n';

import { changeConversationToReciprocal } from '../../actions/conversations';
import Conversation from '../../models/Conversation';
import User from '../../models/User';

export class EditableExchangeType extends React.PureComponent {
    static propTypes = {
        conversation: PropTypes.instanceOf(Conversation).isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        changeToReciprocal: PropTypes.func.isRequired,
        deleteReciprocal: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            show: false
        };

        this.closeEditableExchangeType = this.closeEditableExchangeType.bind(this);
        this.handleExchangeTypeChange = this.handleExchangeTypeChange.bind(this);
        this.toggleEditableExchangeType = this.toggleEditableExchangeType.bind(this);
    }

    handleExchangeTypeChange(event) {
        const type = event.target.value;
        // do nothing if not changed
        if (_.isEqual(type, this.props.conversation.getExchangeType())) {
            this.setState({ show: false });
        }
        // alert user for modification
        if (this.props.conversation.getExchange().isApproved()) {
            sweetAlert({
                title: i18n.t('exchange:confirm_update_title'),
                text: i18n.t('exchange:confirm_update_text'),
                icon: 'warning',
                buttons: [i18n.t('common:cancel'), i18n.t('common:continue')]
            }).then((isConfirm) => {
                if (isConfirm) {
                    this.updateExchangeType(type);
                } else {
                    // force update to reset value
                    this.forceUpdate();
                }
            });
        } else {
            this.updateExchangeType(type);
        }

        this.closeEditableExchangeType();
    }

    updateExchangeType(type) {
        switch (type) {
            case 'simple':
                this.deleteReciprocal();
                break;
            case 'mutual':
                this.changeToReciprocal();
                break;
            default:
                throw new Error('Unknow exchange type');
        }
        this.forceUpdate();
    }

    deleteReciprocal() {
        if (this.props.conversation.isMutual()) {
            const exchange = _.last(this.props.conversation.get('exchanges'));
            this.props.deleteReciprocal(this.props.conversation.id, exchange.id);
            this.loading();
        }
    }

    changeToReciprocal() {
        if (this.props.conversation.isMutual() === false) {
            this.props.changeToReciprocal(this.props.conversation);
            this.loading();
        }
    }

    isGuest() {
        // is guest on the initial exchange
        const guest = this.props.conversation.get('exchanges')[0].get('guest');
        return guest && guest.id == this.props.user.id;
    }

    toggleEditableExchangeType() {
        if (!this.props.conversation.isInExchangeModificationFlowAndShouldBuyGp()) {
            this.setState({ show: !this.state.show });
        }
    }

    closeEditableExchangeType() {
        this.setState({ show: false });
    }

    loading() {
        const header = document.querySelector('.exchange-header');
        if (header) {
            header.dispatchEvent(new CustomEvent('loading'));
        }
    }

    render() {
        return (
            <div className="form-group exchange-type">
                <div className="modify-exchange">
                    <label>{i18n.t('exchange:exchange.type')}</label>
                    <div
                        className={classNames({
                            'no-cursor': this.props.conversation.isInExchangeModificationFlowAndShouldBuyGp()
                        })}
                        onClick={this.toggleEditableExchangeType}
                    >
                        <span>{i18n.t(`exchange:${this.props.conversation.getExchangeTypeShort()}`)}</span>
                        {!this.props.conversation.isInExchangeModificationFlowAndShouldBuyGp() && (
                            <button className="btn-link btn-edit">
                                <Icon name="Pencil" title={i18n.t('common:edit')} aria-hidden="true" />
                                <span className="sr-only">{i18n.t(`common:edit`)}</span>
                            </button>
                        )}
                    </div>
                </div>
                <div
                    className={classNames('exchange-type-selection', {
                        show: this.state.show
                    })}
                >
                    <form className="gtg-form">
                        <div className="radio">
                            <label className="type-mutual">
                                <div className="radio-button-container">
                                    <input
                                        type="radio"
                                        name="exchange-type"
                                        value="mutual"
                                        checked={this.props.conversation.getExchangeType() === 'mutual'}
                                        onChange={this.handleExchangeTypeChange}
                                    />
                                    <div className="radio-button"></div>
                                    <span className="exchange-type-label">
                                        {i18n.t(`exchange:reciprocal`)}
                                    </span>
                                    <div className="exchange-type-description">
                                        {i18n.t('exchange:mutual.definition', {
                                            first_name: this.props.conversation
                                                .get('interlocutor')
                                                .get('first_name')
                                        })}
                                    </div>
                                </div>
                            </label>
                        </div>
                        <div className="radio">
                            <label className="type-simple">
                                <div className="radio-button-container">
                                    <input
                                        type="radio"
                                        value="simple"
                                        name="exchange-type"
                                        checked={this.props.conversation.getExchangeType() === 'simple'}
                                        onChange={this.handleExchangeTypeChange}
                                    />
                                    <div className="radio-button"></div>
                                    <span className="exchange-type-label">
                                        {i18n.t(`exchange:non.reciprocal`)}
                                    </span>
                                    <div className="exchange-type-description">
                                        <span>
                                            {this.isGuest()
                                                ? i18n.t('exchange:simple_definition_guest', {
                                                      first_name: this.props.conversation
                                                          .get('interlocutor')
                                                          .get('first_name')
                                                  })
                                                : i18n.t('exchange:simple_definition_host', {
                                                      first_name: this.props.conversation
                                                          .get('interlocutor')
                                                          .get('first_name')
                                                  })}
                                            <br />

                                            <a
                                                href={i18n.t('url:gp-cms')}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {i18n.t('exchange:simple_definition_gp.link')}
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    changeToReciprocal: bindActionCreators(changeConversationToReciprocal, dispatch)
});

export default connect(null, mapDispatchToProps)(EditableExchangeType);
